module.exports = __webpack_public_path__ + "static/media/werewolf.b64bb8f9.mp3";